import { render } from "./TheProfessionalDocumentGrid.vue?vue&type=template&id=6624d6f4&scoped=true&ts=true"
import script from "./TheProfessionalDocumentGrid.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalDocumentGrid.vue?vue&type=script&lang=ts"

import "./TheProfessionalDocumentGrid.vue?vue&type=style&index=0&id=6624d6f4&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6624d6f4"]])

export default __exports__